/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import {
  API_SERVICE,
  ApiBasedService,
  ConvertForDataTestPipe,
  EMPTY_STRING,
  ListItemResource,
  ListResource,
  StateResource,
} from '@common/tech-shared';
import { CommonModule } from '@angular/common';
import { Component, ContentChild, EventEmitter, inject, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { Resource } from '@ngxp/rest';
import { SpinnerComponent } from '@ods/component';
import { RoutingButtonComponent } from '@ods/system';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'administration-list-template',
  templateUrl: './list-template.component.html',
  imports: [CommonModule, RoutingButtonComponent, SpinnerComponent, ConvertForDataTestPipe],
  host: { class: 'flex flex-col gap-4' },
})
export class ListTemplateComponent implements OnInit, OnDestroy {
  private readonly service: ApiBasedService<Resource, Resource, Resource, ListResource, ListItemResource, any> =
    inject(API_SERVICE);

  @Input() header: string;

  @Input() newButtonText: string = undefined;
  @Input() addPath: string = undefined;

  @Input() emptyListText: string = EMPTY_STRING;
  @Input() isRelativePath: boolean = false;

  @Input() listStateResource: StateResource<ListResource>;
  @Output() listStateResourceChange: EventEmitter<StateResource<ListResource>> = new EventEmitter();

  @ContentChild(TemplateRef) itemTemplate!: TemplateRef<unknown>;

  public isListEmpty$: Observable<boolean>;
  public subscription: Subscription;

  ngOnInit(): void {
    this.subscription = this.service
      .getList()
      .subscribe((stateResource: StateResource<ListResource>) => this.listStateResourceChange.emit(stateResource));
    this.isListEmpty$ = this.service.isListEmpty();
  }

  ngOnDestroy(): void {
    this.service.clearList();
    this.subscription.unsubscribe();
  }
}
